// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".training-back-content .accuracy-thead th{background-color:#2cb774!important;color:#fff!important}", ""]);
// Exports
module.exports = exports;
